import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Input from 'shared-web/src/components/Input'
import style from './style.styl'

class InputWithLimit extends Component {
  static propTypes = {
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    maxLength: PropTypes.number.isRequired,
    invalidLabel: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
  }

  static defaultProps = {
    size: "medium"
  }

  state = this.getStateFromProps(this.props)

  componentWillReceiveProps(nextProps) {
    this.setState(this.getStateFromProps(nextProps))
  }

  getStateFromProps(props) {
    return {
      text: props.text,
      valid: this.validate(props.text, props.maxLength)
    }
  }

  render() {
    const { text, valid } = this.state
    const {
      title,
      placeholder,
      maxLength,
      invalidLabel,
      className,
      onChange,
      ...rest,
    } = this.props

    const length = text ? maxLength - text.length : maxLength

    return (
      <div className={classNames(style.InputWithLimit, className)}>
        <div className={`${style.InputWithLimit__Label}`}>
          <span>{title}</span>
          <span>{length}</span>
        </div>
        <Input
            className={style.TextInput}
            isTextAreaAutosize={true}
            placeholder={placeholder}
            valueLink={{
              requestChange: this.handleChange,
              value: text
            }}
            isValid={valid}
            invalidLabel={ !valid ? invalidLabel : '' }
            {...rest}
        />
      </div>
    )
  }

  handleChange = (text) => {
    if (text === this.state.text) return
    
    const { onChange, maxLength } = this.props
    const valid = this.validate(text, maxLength)
    this.setState({ text, valid })
    onChange(text, valid)
  }

  validate(text, maxLength) {
    if (text) {
      return text.length <= maxLength && text.length > 0
    }
    return true
  }
}

export default InputWithLimit



// WEBPACK FOOTER //
// ./src/scripts/components/Customize/InputWithLimit/index.js